<template>
	<div id="systemmodule">
		<HrrBreadcrumb PMname="其他功能" CMname="卡片信息管理" />
		<HrrMainLayout>
			<template slot="searh">
				<el-form :inline="true" :model="searchform">
					<el-form-item label="供应商：">
						<el-select v-model="searchform.supplier"  placeholder="请选择" >
                            <el-option 
							label="全部" 
							value=""></el-option>
							<el-option v-for="item in supplierData" 
							:key="item.supplier"
							:label="item.supplier" 
							:value="item.supplier">
							</el-option>
						</el-select>
					</el-form-item>
                    <el-form-item label="批次号：">
						<el-select v-model="searchform.batch"   placeholder="请选择" >
                            <el-option 
							label="全部" 
							value=""></el-option>
							<el-option v-for="item in batchData" 
							:key="item.batch"
							:label="item.batch" 
							:value="item.batch">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item >
						<el-input v-model="keyword" placeholder="关键字" >
							<el-select v-model="selectfield" slot="prepend" placeholder="请选择" class="input-with-select">
						      <el-option label="卡号编号" value="cardCode"></el-option>
						    </el-select>
						</el-input>
					</el-form-item>
                    <el-form-item >
						<el-checkbox v-model="isExportData" @change="changeExport" >已导出</el-checkbox>
					</el-form-item>
                    <el-form-item >
						<el-checkbox v-model="searchform.isHaveAdId">已绑定广告</el-checkbox>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit">查询</el-button>
					</el-form-item>
				</el-form>
			</template>
			<template slot="buttons">
				<el-button-group>
					<el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick" v-if="isHadFun('BatchAdd')">批量添加</el-button>
                    <el-button type="primary" icon="el-icon-download" size="small" @click="Exportclick" v-if="isHadFun('Export')">导出</el-button>
					<el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick" v-if="false">编辑</el-button>
					<el-button type="primary" icon="el-icon-delete" size="small" @click="delclick" v-if="false">删除</el-button>
					<el-button type="primary" icon="fa fa-check-square-o" size="small" v-if="false">审核</el-button>
				</el-button-group>
			</template>
			<template slot="table">
				<el-table  :data="tableData" ref="Opentable" @cell-click="cellclick" @selection-change="selectionchange"
				border 
				stripe 
				style="width: 100%" 
				v-loading="loading"  >
				<el-table-column type="selection" width="55" fixed="left">
				</el-table-column>
				<!-- <el-table-column prop="lightBoxId" label="序号" width="90" fixed="left" sortable>
				</el-table-column> -->
				<el-table-column prop="cardId" label="卡号" width="90" fixed="left" sortable>
    			</el-table-column>
				<el-table-column prop="cardCode" label="卡号编号" width="240" fixed="left" sortable >
				</el-table-column>
                <el-table-column prop="supplier" label="供应商" width="240" fixed="left" sortable >
				</el-table-column>
				<el-table-column prop="batch" label="批次号" width="200">
				</el-table-column>
				<el-table-column label="是否导出过" width="120">
                    <template slot-scope="scope">
                    <div  disable-transitions>{{scope.row.isExport?'是':'否'}}</div>
                    </template>
				</el-table-column>
				<el-table-column prop="exportNum" label="导出次数" width="90">
				</el-table-column>
				<el-table-column prop="lastExportDate" label="上次导出时间" width="160">
				</el-table-column>
                <el-table-column  label="是否绑定广告" width="140">
                    <template slot-scope="scope">
                    <div  disable-transitions>{{scope.row.isHaveAdId?'是':'否'}}</div>
                    </template>
				</el-table-column>
                <el-table-column prop="adTitle" label="广告名称" width="140">
				</el-table-column>
				<el-table-column prop="creationDate" label="创建时间" width="200" sortable>
				</el-table-column>
				<el-table-column prop="creationBy" label="创建人" width="100">
				</el-table-column>
				<!-- <el-table-column label="操作" width="200" fixed="right">
					<template slot-scope="scope">
						<el-button @click.stop="Rowview(scope.row)" type="text" size="small">查看</el-button>
						<el-button @click.stop="RowEdit(scope.row)" type="text"  size="small" >编辑</el-button>
						<el-button @click.stop="Rowdelete(scope.row)" type="text"  size="small" >删除</el-button>
					</template>
				</el-table-column> -->
			</el-table>
		</template>
		<template slot="Pagination">
			<el-pagination
			background
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="searchform.pageNum"
			:page-sizes="[5, 10, 15]"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total">
		</el-pagination>
	</template>
</HrrMainLayout>
</div>
</template>
<script>
	export default {
		name: 'Card_info',
		data(){
			return{
				searchform:{
					pageNum:1,
                    pageSize:10,
                    supplier:"",
					cardCode:"",
                    batch:"",
                    isExport:"",
                    isHaveAdId:"",
                },
                isExportData:"",
				tableData:[],
				total:0,
				loading:true,
				selectionRows:[],
				selectfield:"cardCode",
                supplierData:[],
                batchData:[],
				keyword:"",
				baseURL:this.$hrraxios.defaults.baseURL,
			}
		},
		methods:{
			onSubmit(){
				this.searchform.cardCode="";
				this.searchform.pageNum=1;
				this.searchform[this.selectfield]=this.keyword.trim();
				this.$route.meta.Cardinfo=this.searchform
				this.initData();
			},
			Exportclick(){
				window.open(this.baseURL+"/api/Card/export"+"?pageNum="+this.searchform.pageNum+"&pageSize="+this.searchform.pageSize+"&supplier="+this.searchform.supplier+"&cardCode="+this.searchform.cardCode+"&batch="+this.searchform.batch+"&isExport="+this.searchform.isExport+"&isHaveAdId="+this.searchform.isHaveAdId+"");
				//this.$hrraxios.get(this.$api.card.getExport, {params:this.searchform})
			},
			handleSizeChange(val) {
				this.searchform.pageSize=val;
				this.initData();
			},
			handleCurrentChange(val) {
				this.searchform.pageNum=val;
				this.initData();
			},
			Addclick(){
				this.$router.push({path:'/card/info/add/',});
			},
			cellclick(row, column, cell, event){
				this.$refs.Opentable.toggleRowSelection(row);
			},
			selectionchange(selection){
				this.selectionRows=selection;
			},
			changeExport(val){
				if(this.isExportData==true){
                    this.searchform.isExport=1
                }else{
                    this.searchform.isExport=0
                }
				this.initData();
			},
			initData(){
				var Vuethis=this;
				this.loading=true;
				this.$hrraxios.get(this.$api.card.getCard, {params:this.searchform})
				.then(function (response) {
					Vuethis.loading=false;
					var data=response.data;
					if(data.Success==true)
					{
						Vuethis.tableData=data.Data.List;
						Vuethis.total=data.Data.Total;
					}else{
						Vuethis.$message.error(data.Prompt);
					}
				})
				.catch(function (error) {
					Vuethis.loading=false;
					console.log(error);
				});
			},
			cardSupplier(){
				var Vuethis=this;
				this.$hrraxios.get(this.$api.card.getSupplier)
				.then(function (response) {
					var data=response.data;
					if(data.Success==true)
					{
						Vuethis.supplierData=data.Data;
					}else{
						Vuethis.$message.error(data.Prompt);
					}
				})
				.catch(function (error) {
					console.log(error);
				});
            },
            cardBatch(){
				var Vuethis=this;
				this.$hrraxios.get(this.$api.card.getBatch)
				.then(function (response) {
					var data=response.data;
					if(data.Success==true)
					{
						Vuethis.batchData=data.Data;
					}else{
						Vuethis.$message.error(data.Prompt);
					}
				})
				.catch(function (error) {
					console.log(error);
				});
			},
		},
		beforeRouteLeave(to, from, next) {
			// 导航离开该组件的对应路由时调用
			to.meta.row=from.meta.row;
			to.meta.Cardinfo=from.meta.Cardinfo;
			next();
		},
		created(){
			this.$common.getFunListByMCode(this,"CardInfo",()=>{
				if(this.$route.meta.Cardinfo !=undefined){
					var searchformData=this.$route.meta.Cardinfo
					this.searchform.pageNum=searchformData.pageNum;
					this.searchform.pageSize=searchformData.pageSize;
					if(searchformData.supplier!=""){
						this.searchform.supplier=searchformData.supplier;
					}
					if(searchformData.cardCode!=""){
						this.selectfield="cardCode";
						this.keyword=searchformData.cardCode;
						this.searchform.cardCode=searchformData.cardCode;
					}
					if(searchformData.batch!=""){
						this.searchform.batch=searchformData.batch;
					}
				}
				this.initData();
				this.cardSupplier();
				this.cardBatch();
				this.searchform.isExport=""
			});
		}
	}
</script>
<style >
  .input-with-select { width: 110px;}
	.educard label {color: #99a9bf;}
	.educard{margin-bottom: 10px;}
	.utable .el-button,.utable .el-button+.el-button{margin-right: 10px;margin-left: 0;}
  #lightForm .el-select{width: 100px;}
</style>
